module.exports = __webpack_public_path__ + "img/avi.cf488874.png";